<div id="cutomer-profile-utf-screen" [ngStyle]="{ 'height.px': divHeight1 }">
  <div class="row no-gutters" [ngStyle]="{ 'height.px': divHeight1 }">
    <div class="col-lg-4" id="progress-tracker">
      <app-progress-tracker [stepOneIcon]="stepOneIcon" [stepOneTickIcon]="stepOneTickIcon" [stepOneDone]="stepOneDone"
        [stepThreeCreatePwdPage]="stepThreeCreatePwdPage" [stepTwoProfileDone]="stepTwoProfileDone"
        [stepTwoDone]="stepTwoDone" [progressTrackerStatus]="progressTrackerStatus"></app-progress-tracker>
    </div>
    <div class="col-lg-8" id="form-component-section" *ngIf="showPasswordScreen">
      <app-complete-profile-utf-form (openTermsPage)="openTermsPage($event)" (showCodeSection)="showCodeSection($event)"
        [showWeekPassword]="showWeekPassword">
      </app-complete-profile-utf-form>
    </div>
    <div id="terms-condition" *ngIf="showTermsCondition">
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <div id="terms-heading">
            <p id="terms_heading">{{cfetLabels.cfet_terms_condition.heading}}</p>
          </div>
          <div id="terms-date">
            <p>{{cfetLabels.cfet_terms_condition.terms_date}}</p>
            <p>{{cfetLabels.cfet_terms_condition.terms_date1}}</p>
          </div>
          <div id="terms-intro">
            <p><strong>{{cfetLabels.cfet_terms_condition.introduction}}</strong></p>
          </div>
          <div id="terms-desc">
            <p>{{cfetLabels.cfet_terms_condition.desc1}}</p>
            <p>{{cfetLabels.cfet_terms_condition.desc2}}</p>
            <p>{{cfetLabels.cfet_terms_condition.desc3}}</p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info1"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info2"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info3"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info4"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info5"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.sub_info5"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info6"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info7"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info8"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info9"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info10"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info11"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info12"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info13"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info14"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info15"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.info16"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.general_info1"></p>
            <p [innerHTML]="cfetLabels.cfet_terms_condition.general_info2"></p>
            <p id="general_info" [innerHTML]="cfetLabels.cfet_terms_condition.general_info3"></p>
          </div>
        </div>
        <div class="col-md-3 terms-close-icon">
          <picture>
            <source media="(min-width: 280px)" srcset="assets/images/Close_32px.png">
            <img id="close-icon" (click)="closeTerms($event)" (keyup)="closeTerms($event)"
              src="assets/images/Close_32px.png" alt="Close icon" tabindex="0">
          </picture>
        </div>
      </div>
    </div>
    <div class="col-lg-8" id="form-component-section" *ngIf="showOTPScreen">
      <app-customer-profile-utf-form (showCompleteProfile)="showCompleteProfile($event)"
      (goBackToPwdPage)="goBackToPwdPage($event)">
      </app-customer-profile-utf-form>
    </div>
  </div>
</div>